import { Grid } from '@changegps/horizon-component-library';
import { Stack, Typography } from '@mui/material';

import { PlanForm } from '../hooks';

type ProductsRow = PlanForm & {
  type?: string;
  product: string;
  tag: string;
};

export const ProductRow = (props: ProductsRow) => {
  return (
    <Grid
      columns={4}
      sx={{
        borderBottom: '1px solid #E5E3E3',
        padding: '25px 40px 20px',
        gridTemplateColumns: '1fr .1fr .1fr .15fr',
      }}
    >
      <Stack>
        <Typography
          mt={1}
          fontSize={22}
          fontWeight={600}
          textTransform={'uppercase'}
        >
          {props.product} - {props.type}
        </Typography>
        <Typography fontSize={15} fontWeight={200}>
          {props.tag}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Typography fontSize={16} fontWeight={200}>
          ${props?.price}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Typography fontSize={16} fontWeight={200}>
          {props.type && props.type.toLowerCase().includes('enterprise')
            ? props.count
            : props?.users?.max}{' '}
          users
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Typography fontSize={20} fontWeight={600}>
          $ {props?.price}
        </Typography>
      </Stack>
    </Grid>
  );
};
